import Authentication from './authentication';
import SigninCallbackComponent from './signinCallbackComponent';
import SilentRedirectCallbackComponent from './silentRedirectCallbackComponent';

export default {
    Authentication,
    SigninCallbackComponent,
    SilentRedirectCallbackComponent
}
